import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
export const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-2 footer">
      &copy; Mega-Test Project
    </footer>
  );
};
